<template>
    <div>
        <iframe v-if="isPdf" ref="pdfIframe" class="pdf-container" :src="documentUrl" @load="handleIframeLoad"></iframe>
        <img v-else :src="documentUrl" alt="Image" class="image-container" />
    </div>
</template>

<script>
import settings from "@/settings";

export default {
    name: "PdfViewer",
    props: {
        fileId: Number,
        isPdf: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            documentUrl: null
        };
    },
    async mounted() {
        this.documentUrl = await this.fetchDocumentUrl();
    },
    methods: {
        async fetchDocumentUrl() {
            let params = "?act=stream";
            params += "&file_id=" + this.fileId;
            return settings.api_url + "/file" + params;
        },
        handleIframeLoad() {
            if (!this.isLoaded) {
                const iframe = this.$refs.pdfIframe;
                iframe.style.height = iframe.contentWindow.document.body.scrollHeight + "px";
                this.isLoaded = true;
            }
        }
    }
};
</script>

<style scoped>
.pdf-container {
    width: 100%;
    height: 1056px;
}

.image-container {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
}
</style>
